const i = (s, { service: t, level: r = "info", env: o = "local" }) => ({
  // Expected to already be a valid pino level (use `normalizeLevel` at the call site).
  level: r,
  timestamp: s.stdTimeFunctions.isoTime,
  // Queryable base fields; also drops the noisy default `pid`/`hostname`.
  base: { service: t, env: o },
  // String levels (`"error"`) instead of pino's numeric — far better for log filtering.
  formatters: {
    level: (e) => ({ level: e })
  },
  // Keep request/response logs minimal so we never leak auth headers / bodies.
  serializers: {
    req: (e) => ({
      method: e.method,
      url: e.url
    }),
    res: (e) => ({ statusCode: e.statusCode }),
    // Ensure Error objects are serialized with their stack in logs (and Sentry).
    err: s.stdSerializers.err
  }
});
export {
  i as createBasePinoOptions
};
